import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Input, Icon, Tooltip } from 'antd'
import { sendNotification, isEmail } from '../../utils/index'
import { KEY_CODE_DELETE, KEY_CODE_ENTER } from '../../utils'
import Helper from '../helper/Helper'
import { addTagsConfirmAsset } from '../../actions/AssetsConfirmAction'
import './tagV2.css'

export class TagsV2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tags: [],
      placeholder: this.props.intl.formatMessage({ id: "tags_add_new_tag" }),
      inputTags: '',
      defaultTags: [],
    }
  }

  componentDidMount() {
    const { fillTags } = this.props
    if (fillTags) {
      this.setState({
        tags: fillTags
      })
    }
    document.addEventListener('keydown', this.handleKeyPressArrow, { once: false })
  }

  componentDidUpdate(prevProps) {
    const { fillTags } = this.props
    if (prevProps.fillTags !== fillTags) {
      this.setState({
        tags: fillTags
      })
    }
  }

  handleAddition = () => {
    const { tags, inputTags } = this.state
    const { validateIsEmail, intl } = this.props

    if (validateIsEmail && inputTags !== '') {
      const inputAllEmail = inputTags.split(',').map(r => r.trim())
      const validEmail = []

      inputAllEmail.forEach(email => {
        if (!isEmail(email)) {
          sendNotification('warning', intl, intl.formatMessage({ id: 'invalid_mail' }))
          this.props.handleError(true)
          return
        } else {
          this.props.handleError(false)
          validEmail.push(email)
        }
      })

      if (validEmail.length > 0) {
        const arrFinal = tags.concat(validEmail).reduce((x, y) => x.map(z => z.toLowerCase()).includes(y.toLowerCase()) ? x : [...x, y], [])
        this.setState({
          tags: arrFinal,
          inputTags: ''
        }, () => this.props.handleTags({ tags: [...this.state.tags] }))
      }
    }

    if (inputTags !== '' && inputTags.trim() && !validateIsEmail) {
      const arr = inputTags.split(',').map(r => { return r.trim() })
      let arrFinal = tags.concat(arr)
        .reduce((x, y) => {
          if (x.map(x => x.trim().toLowerCase()).includes(y.trim().toLowerCase())) sendNotification('error', intl, intl.formatMessage({ id: 'duplicate_tag' }))
          return x.map(x => x.trim().toLowerCase()).includes(y.trim().toLowerCase()) ? x : [...x, y]
        }, [])

      this.setState({
        tags: arrFinal,
        inputTags: ''
      }, () => this.props.handleTags({ tags: [...this.state.tags] }))
    }
  }

  handleKeyPressArrow = e => {
    const fromTag = e.target.getAttribute('from')
    switch (e.keyCode) {
      case KEY_CODE_DELETE:
        if (fromTag) this.handleRemove(fromTag)
        break
      case KEY_CODE_ENTER:
        this.handleAddition()
        break
      default:
        break
    }
  }

  handleRemove = tag => {
    const { tags } = this.state
    this.setState(({
      tags: tags.filter((r) => r !== tag)
    }), () => this.props.handleTags({ tags: [...this.state.tags] }))
  }

  handleCopyClipboard = () => {
    const { tags } = this.state
    const { intl } = this.props

    const isOs = navigator.userAgent.match(/ipad|iphone/i)

    if (tags && tags.length > 0) {
      const tagsToText = tags.join(',')
      let textField = document.createElement('textarea')
      textField.innerText = tagsToText
      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
      sendNotification('success', intl, intl.formatMessage({ id: "tags_clipboard" }))

      if (isOs) {
        let textArea
        let range
        let selection

        range = document.createRange()
        range.selectNodeContents(textArea)
        selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        textArea.setSelectionRange(0, 999999)

        textArea = document.createElement('textArea')
        textArea.readOnly = true
        textArea.contentEditable = true
        textArea.value = tags
        document.body.appendChild(textArea)

        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }
    else {
      sendNotification('info', intl, intl.formatMessage({ id: "no_tags_copy" }))
    }
  }

  handleOnChange = e => {
    this.setState({ inputTags: (e.target.value) })
  }

  handleOnKeyDown = (e) => {
    const { inputTags, tags } = this.state
    if (inputTags === '' && e.keyCode === KEY_CODE_DELETE) {
      tags.pop()
      this.setState({ tags }, () => {
        if (this.props.hideTags) {
          this.props.handleTags({ tags: [...this.state.tags] })
        }
      })
    }
  }

  render() {
    const { tags, placeholder, inputTags } = this.state
    const { placeholderCustom, validateIsEmail, intl, hideTags } = this.props
    const placeholderComponent = placeholderCustom
      ? placeholderCustom
      : placeholder


    return (
      <React.Fragment>
        {!validateIsEmail && <Helper
          title={"helper_title"}
          content={"helper_tags"}
          trigger={`click`}
          color={(hideTags) ? "#F8F8FA" : null}
        />
        }
        {!validateIsEmail &&
          <Tooltip title={intl.formatMessage({ id: "copy_tags" })}>
            <Icon type='copy' onClick={this.handleCopyClipboard} style={{ color: (hideTags) ? "#F8F8FA" : null }} />
          </Tooltip>
        }
        {!hideTags &&
          <div id="divBtnTags">
            {
              tags.map((r, k) =>
                <button
                  key={k}
                  className="stylebtn tag-wrapper ReactTags__tag"
                  from={r}>
                  {r}
                  <Icon
                    id="removeTags"
                    onClick={(tag) => { this.handleRemove(r) }}
                    style={{ fontSize: '8px', marginLeft: '6px' }} type="close" />
                </button>)
            }
          </div>


        }

        <Input
          value={inputTags}
          onChange={this.handleOnChange}
          placeholder={placeholderComponent}
          allowClear={true}
          autoComplete="new-password"
          onBlur={this.handleAddition}
          onKeyDown={this.handleOnKeyDown}
        />
      </React.Fragment >
    )
  }
}

const mapStateToProps = (state) => ({
  hideDrawer: state.comments.hideDrawer,
})

const mapDispatchToProps = {
  addTagsConfirmAsset
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(TagsV2)))